import { Text } from "react-native-paper";
import { useAppTheme } from "../../../../useAppTheme";
import Box from "../../../Box";

const DOT_SIZE = 8;
const MARKER_WIDTH = 10;
const LABEL_INDENT = 22;

type Props = {
	title: string;
	steps: string[];
};

export const ToeicProgressionSteps = ({ title, steps }: Props) => {
	const theme = useAppTheme();

	return (
		<Box gap={8}>
			<Text variant="labelLarge">{title}</Text>
			<Box>
				{steps.map((step, index) => {
					const isLast = index === steps.length - 1;
					return (
						<Box key={step} flexDirection="row" alignItems="stretch">
							<Box width={MARKER_WIDTH} alignItems="center">
								<Box
									width={DOT_SIZE}
									height={DOT_SIZE}
									borderRadius={DOT_SIZE / 2}
									backgroundColor={theme.colors.primary}
									marginTop={5}
								/>
								{isLast ? null : (
									<Box
										width={1}
										flex={1}
										marginTop={3}
										marginBottom={3}
										backgroundColor={theme.colors.outlineVariant}
									/>
								)}
							</Box>
							<Box
								paddingLeft={LABEL_INDENT - MARKER_WIDTH}
								paddingBottom={isLast ? 0 : 12}
								flex={1}
							>
								<Text variant="bodyMedium">{step}</Text>
							</Box>
						</Box>
					);
				})}
			</Box>
		</Box>
	);
};
